import { Fragment } from "react";
import { UserCheck } from "lucide-react";
import { ROLES } from "@/lib/constants";
import { fmtDateTime } from "@/lib/format";

// "Pasien Datang": when Case Manager/Petugas Admisi marked the patient as physically at the hospital, and by which role.
// Same text as the PDF export's Pasien Datang cell (time + role). "-" when not marked.
// `wrap`: let the time break onto two lines (Antrian compact layout) instead of widening the column.
export default function PasienDatangInfo({ patient, wrap = false }) {
  if (!patient.pasien_datang_at) return <span className="text-slate-400">-</span>;
  return (
    <div className="flex flex-col items-start gap-0.5 text-xs"
      title={patient.pasien_datang_by ? `Ditandai oleh ${patient.pasien_datang_by}` : undefined}>
      <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded border bg-white text-emerald-800 border-emerald-300 text-[11px] font-medium whitespace-nowrap">
        <UserCheck size={11} strokeWidth={2.5} aria-hidden="true" /> Datang
      </span>
      <span className={`text-slate-600 ${wrap ? "" : "whitespace-nowrap"}`}>
        {fmtDateTime(patient.pasien_datang_at).split(" ").map((part, i) => <Fragment key={i}>{i ? " " : ""}<span className="whitespace-nowrap">{part}</span></Fragment>)}
      </span>
      <span className={`text-slate-500 ${wrap ? "" : "whitespace-nowrap"}`}>{ROLES[patient.pasien_datang_role] || patient.pasien_datang_role}</span>
    </div>
  );
}
